import { render, staticRenderFns } from "./index-dev.vue?vue&type=template&id=af2e34fa&scoped=true"
import script from "./index-dev.vue?vue&type=script&lang=js"
export * from "./index-dev.vue?vue&type=script&lang=js"
import style0 from "./index-dev.vue?vue&type=style&index=0&id=af2e34fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af2e34fa",
  null
  
)

export default component.exports